import React, { useState, useEffect } from "react";
import { groupsData } from "../../utils/constants";
import { useNavigate } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import CustomButton from "../custom/CustomButton";
import CustomHeading from "../custom/CustomHeading";
import axiosStrapiInstance, { baseUrl } from "../../axiosStrapi";
import { toast } from "react-toastify";
import Loader from "../custom/Loader";

const Groups = () => {
  const [loading, setLoading] = useState(false);
  const [groups, setGroups] = useState([]);
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 2000,
    cssEase: "linear",
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 2.7,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 900, // Below 900px
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 500, // Below 500px
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const navigate = useNavigate();
  async function getGroups() {
    try {
      setLoading(true);
      const response = await axiosStrapiInstance.get(
        "/api/groups?populate=*&sort=groupId:asc"
      );
      const result = response?.data?.data?.map((item) => ({
        ...item,
        image: `${item?.image?.url}`,
        galleryImages: item?.galleryImages?.map(
          (item) => `${baseUrl}${item?.url}`
        ),
      }));
      setGroups(result);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while submiting form", error);
      if (error?.response?.data?.error?.message) {
        toast.error(error?.response?.data?.error?.message);
      }
    }
  }
  useEffect(() => {
    getGroups();
  }, []);
  return (
    <div
      id="groups"
      className="bg-[#E0FAFF] px-[8%] py-[2%] flex flex-col gap-[1rem]"
    >
      <CustomHeading
        text={"Our "}
        showHeart={true}
        spanText={"Groups"}
        smTextSize="32px"
        heartPosition="absolute"
      />
      {loading ? (
        <Loader backgroundColor={"#E0FAFF"} />
      ) : (
        <div className="w-full mx-auto gap-10">
          {/* <Slider {...settings}></Slider> */}
          <Slider {...settings} className="sm:pl-0 pl-5 sm:px-5 pb-3 px-2">
            {groups.map((member, index) => (
              <div
                onClick={() => window.open(member?.redirectionLink)}
                className="flex bg-transparent cursor-pointer items-center justify-center max-h-[280px] max-w-[280px] rounded-xl"
              >
                <img
                  src={member?.image}
                  alt="groups img"
                  className=" h-[200px] w-[240px]"
                />
              </div>
            ))}
          </Slider>
        </div>
      )}

      <CustomButton
        text={"See all"}
        paddingY="14px"
        marginX={"auto"}
        marginY="10px"
        width="185px"
        handleClick={() => {
          navigate("/groups");
        }}
      />
    </div>
  );
};

export default Groups;
